// S28: Forgot Password Page
import { useState } from 'react';
import { Form, Input, Button, Typography, Alert, Space } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../api/passwordEndpoints';

const { Title, Text, Paragraph } = Typography;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (values: { email: string }) => {
    setLoading(true);
    setError(null);

    try {
      await forgotPassword({ email: values.email });
      setSubmitted(true);
    } catch (err: any) {
      // Even on error, show generic message (security)
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: '#000000',
          padding: '24px',
        }}
      >
        <div style={{ width: '100%', maxWidth: 480 }}>
          <Space orientation="vertical" size="large" style={{ width: '100%' }}>
            <div
              style={{
                background: '#1a1a1a',
                borderRadius: '12px',
                padding: '48px',
                border: '1px solid #2a2a2a',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img 
                  src="/images/logo.png" 
                  alt="DivvyStash" 
                  style={{ 
                    maxWidth: '200px',
                    height: 'auto',
                    marginBottom: '24px'
                  }} 
                />
                <MailOutlined style={{ fontSize: 64, color: '#52c41a', marginBottom: '24px' }} />
              </div>

              <div style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#ffffff', marginBottom: '16px' }}>
                  Check your email
                </Title>
                <Paragraph style={{ color: '#b0b0b0', marginBottom: '16px' }}>
                  If an account exists with the email you provided, you will
                  receive a password reset link shortly.
                </Paragraph>
                <Paragraph style={{ color: '#808080' }}>
                  The link will expire in 1 hour. If you don't receive an email,
                  check your spam folder or try again.
                </Paragraph>
              </div>

              <Button
                type="primary"
                block
                size="large"
                onClick={() => navigate('/login')}
                style={{ marginTop: '24px' }}
              >
                Return to Login
              </Button>
            </div>
          </Space>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#000000',
        padding: '24px',
      }}
    >
      <div style={{ width: '100%', maxWidth: 480 }}>
        <Space orientation="vertical" size="large" style={{ width: '100%' }}>
          <div
            style={{
              background: '#1a1a1a',
              borderRadius: '12px',
              padding: '48px',
              border: '1px solid #2a2a2a',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '32px' }}>
              <img 
                src="/images/logo.png" 
                alt="DivvyStash" 
                style={{ 
                  maxWidth: '200px',
                  height: 'auto',
                  marginBottom: '24px'
                }} 
              />
              <Title level={3} style={{ color: '#ffffff', marginBottom: '8px' }}>
                Forgot your password?
              </Title>
              <Text style={{ color: '#b0b0b0' }}>
                Enter your email address and we'll send you a link to reset your
                password.
              </Text>
            </div>

            {error && (
              <Alert message={error} type="error" showIcon closable style={{ marginBottom: '24px' }} />
            )}

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              autoComplete="off"
            >
              <Form.Item
                label={<span style={{ color: '#b0b0b0' }}>Email address</span>}
                name="email"
                rules={[
                  { required: true, message: 'Please enter your email address' },
                  { type: 'email', message: 'Please enter a valid email address' },
                ]}
              >
                <Input
                  prefix={<MailOutlined style={{ color: '#808080' }} />}
                  placeholder="you@example.com"
                  size="large"
                  autoFocus
                  style={{
                    background: '#0a0a0a',
                    border: '1px solid #2a2a2a',
                    color: '#ffffff',
                  }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                >
                  Send Reset Link
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: 'center' }}>
              <Button
                type="link"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate('/login')}
                style={{ color: '#b0b0b0' }}
              >
                Back to Login
              </Button>
            </div>
          </div>
        </Space>
      </div>
    </div>
  );
};

export default ForgotPassword;
